import { render } from "./ProductDetailsHeader.vue?vue&type=template&id=6b6c4556&scoped=true&lang=true"
import script from "./ProductDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ProductDetailsHeader.vue?vue&type=script&lang=js"

import "./ProductDetailsHeader.vue?vue&type=style&index=0&id=6b6c4556&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6c4556"]])

export default __exports__